/* Moood - Bouton "Creer ma wishlist" (panier moood.fr <-> outils.moood.fr)
 * --------------------------------------------------------------------------
 * Gere le clic sur les boutons :
 *   - #create-wishlist-btn      (tiroir / cart-drawer.liquid)
 *   - #create-wishlist-btn-page (page panier / main-cart-items.liquid)
 *
 * Logique :
 *   1. Lit le panier via /cart.js
 *   2. Pre-check non-vide -> alert si vide
 *   3. Mappe les items (variant_id, product_id, properties non-techniques, etc.)
 *   4. Detecte cookie moood_architect=1 pour mode 'architect' vs 'client'
 *   5. Redirige vers outils.moood.fr/from-cart?data=<JSON>&mode=<mode>
 *
 * Pourquoi un asset .js et non du <script> inline en section :
 *   les <script> inline dans les sections Liquid ne s executaient pas (ni
 *   au load, ni apres re-render AJAX du drawer par module-add-to-cart.js).
 *   Un asset charge via <script src ... defer> tourne de facon fiable.
 *
 * Strategie de binding (resistante au timing) :
 *   - DOMContentLoaded gate
 *   - Binding initial immediat (independant de NextSkyTheme)
 *   - Polling NextSkyTheme.subscribe toutes les 50ms (timeout 3s) avec
 *     re-call de attachToButtons() a chaque tick pour rattraper un drawer
 *     re-render entre temps
 *   - Filet window.load : dernier attachToButtons() apres tous les inits
 *   - Souscription cartUpdate quand NextSkyTheme dispo : re-attach apres
 *     chaque update AJAX du panier (double rAF pour le DOM stable)
 *
 * Idempotence : flag data-mood-bound = '1' pose sur chaque bouton bind.
 * attachToButtons() est safe a appeler N fois, skip les boutons deja bind.
 */

(function() {
  if (window.__moodCreateWishlistInit) return;
  window.__moodCreateWishlistInit = true;

  async function handleClick(e) {
    e.preventDefault();
    var btn = e.currentTarget;
    if (!btn) return;

    var originalText = btn.textContent;
    btn.style.pointerEvents = 'none';
    btn.textContent = 'Préparation...';
    try {
      var res = await fetch('/cart.js');
      var cart = await res.json();
      if (!cart.items || cart.items.length === 0) {
        alert('Le panier est vide.');
        btn.style.pointerEvents = '';
        btn.textContent = originalText;
        return;
      }
      var items = cart.items.map(function(it) {
        var props = {};
        if (it.properties && typeof it.properties === 'object') {
          Object.entries(it.properties).forEach(function(entry) {
            var k = entry[0], v = entry[1];
            if (!k.startsWith('_') && v !== null && v !== '') props[k] = v;
          });
        }
        return {
          variant_id: it.variant_id,
          product_id: it.product_id,
          title: it.product_title,
          variant_title: (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : null,
          price: it.final_price / 100,
          image_src: it.featured_image ? it.featured_image.url : (it.image || null),
          quantity: it.quantity,
          properties: props
        };
      });
      var isArchitect = document.cookie.split('; ').some(function(c) { return c.indexOf('moood_architect=1') === 0; });
      var mode = isArchitect ? 'architect' : 'client';
      // POST (form) au lieu de GET : le panier complet passait dans l'URL
      // (?data=<json>) et dépassait la limite ~14 KB de Vercel dès ~10 lignes
      // -> "Données panier illisibles". Le POST met le payload dans le corps,
      // aucune limite. L'ERP stashe puis redirige vers ?stash=<uuid> (cf.
      // handoff from-cart-POST-support-ready). enctype par défaut =
      // application/x-www-form-urlencoded (simple request, pas de preflight CORS).
      // PAS d'encodeURIComponent : le form encode déjà, sinon double-encodage.
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = 'https://outils.moood.fr/from-cart';
      form.style.display = 'none';
      var f1 = document.createElement('input');
      f1.type = 'hidden';
      f1.name = 'data';
      f1.value = JSON.stringify(items);
      var f2 = document.createElement('input');
      f2.type = 'hidden';
      f2.name = 'mode';
      f2.value = mode;
      form.appendChild(f1);
      form.appendChild(f2);
      document.body.appendChild(form);
      form.submit();
    } catch (err) {
      alert('Erreur lors de la lecture du panier.');
      btn.style.pointerEvents = '';
      btn.textContent = originalText;
    }
  }

  function attachToButtons() {
    var nodes = document.querySelectorAll('#create-wishlist-btn, #create-wishlist-btn-page');
    nodes.forEach(function(btn) {
      if (btn.dataset.moodBound === '1') return;
      btn.dataset.moodBound = '1';
      btn.addEventListener('click', handleClick);
    });
  }

  function trySubscribeCartUpdate() {
    if (
      window.NextSkyTheme &&
      typeof NextSkyTheme.subscribe === 'function' &&
      NextSkyTheme.PUB_SUB_EVENTS &&
      NextSkyTheme.PUB_SUB_EVENTS.cartUpdate
    ) {
      NextSkyTheme.subscribe(NextSkyTheme.PUB_SUB_EVENTS.cartUpdate, function() {
        // cartUpdate est emis AVANT le innerHTML replace du drawer
        // (module-add-to-cart.js:89 puis :343). Double rAF pour attraper
        // le nouveau DOM stable.
        requestAnimationFrame(function() {
          requestAnimationFrame(attachToButtons);
        });
      });
      return true;
    }
    return false;
  }

  // Filet universel : MutationObserver. Le bouton du tiroir est injecte
  // dans le DOM par le theme APRES l execution du script defer. Aucun
  // event explicite n est emis a ce moment. L observer detecte l ajout
  // du noeud et rappelle attachToButtons() en synchronisation rAF (max
  // 1 fois par frame, idempotent grace au flag data-mood-bound).
  function startObserver() {
    if (!window.MutationObserver || !document.body) return;
    var pending = false;
    var observer = new MutationObserver(function() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function() {
        pending = false;
        attachToButtons();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    attachToButtons();

    if (!trySubscribeCartUpdate()) {
      var attempts = 0;
      var MAX_ATTEMPTS = 60; // 3s
      var interval = setInterval(function() {
        attempts++;
        attachToButtons();
        if (trySubscribeCartUpdate() || attempts >= MAX_ATTEMPTS) {
          clearInterval(interval);
        }
      }, 50);
    }

    if (document.readyState === 'complete') {
      attachToButtons();
    } else {
      window.addEventListener('load', attachToButtons, { once: true });
    }

    // Filet universel pour les boutons injectes apres DOMContentLoaded.
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
